/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_WhatInputs */

const en_mk_cmp_clickup_what = /** @type {(inputs: Mk_Cmp_Clickup_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClickUp is a very broad work platform: tasks, docs, whiteboards, goals, forms, even chat. Its AI layer (Brain, Super Agents, Ambient Agents) is sold as an add-on: Brain AI $9 or Everything AI $28 per seat on top of the plan price, and that add-on is charged for every paid member whether or not they use it.`)
};

const id_mk_cmp_clickup_what = /** @type {(inputs: Mk_Cmp_Clickup_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClickUp adalah platform kerja yang sangat luas: tugas, dokumen, papan tulis, tujuan, formulir, hingga chat. Lapisan AI-nya (Brain, Super Agents, Ambient Agents) dijual sebagai add-on: Brain AI $9 atau Everything AI $28 per kursi di atas harga paket, dan add-on itu dikenakan ke semua anggota berbayar meski tidak memakainya.`)
};

/**
* | output |
* | --- |
* | "ClickUp is a very broad work platform: tasks, docs, whiteboards, goals, forms, even chat. Its AI layer (Brain, Super Agents, Ambient Agents) is sold as an ad..." |
*
* @param {Mk_Cmp_Clickup_WhatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_what = /** @type {((inputs?: Mk_Cmp_Clickup_WhatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_WhatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_what(inputs)
	return en_mk_cmp_clickup_what(inputs)
});